import { useCallback, useContext } from 'react';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SubmitButton from 'LoginUI/components/legacyLogins/shared/SubmitButton';
import PasswordInputField from 'LoginUI/components/legacyLogins/shared/PasswordInputForm';
import TokenExpiredAlert from 'LoginUI/components/alerts/TokenExpiredAlert';
import { useLoginRequirementsData } from 'LoginUI/hooks/useLoginRequirementsData';
import { trackSmartLoginPasswordLogin } from 'LoginUI/lib/tracker';
import { SmartLoginLandingPageContext } from './SmartLoginLandingPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PasswordField = () => {
  const {
    email,
    submitting,
    useDark,
    setPassword,
    password,
    submittable,
    onPasswordSubmit
  } = useContext(SmartLoginLandingPageContext);
  const handlePasswordSubmit = useCallback(evt => {
    evt.preventDefault();
    trackSmartLoginPasswordLogin('control');
    onPasswordSubmit();
  }, [onPasswordSubmit]);
  return /*#__PURE__*/_jsxs("form", {
    id: "hs-login",
    onSubmit: handlePasswordSubmit,
    children: [/*#__PURE__*/_jsx("input", {
      type: "email",
      hidden: true,
      value: email,
      readOnly: true
    }), /*#__PURE__*/_jsx(PasswordInputField, {
      useDark: useDark,
      onChange: setPassword,
      password: password,
      submitting: submitting,
      query: ''
    }), /*#__PURE__*/_jsx(TokenExpiredAlert, {}), /*#__PURE__*/_jsx(SubmitButton, {
      submitting: submitting,
      disabled: !submittable
    })]
  });
};
const PasswordComponent = () => {
  const {
    additionalSsoPortal,
    availableLogins,
    loginRequirementPortalId
  } = useContext(SmartLoginLandingPageContext);
  const {
    isPasswordLoginAvailable,
    isPasswordLoginHidden
  } = useLoginRequirementsData({
    additionalSsoPortal,
    availableLogins,
    loginRequirementPortalId
  });
  if (isPasswordLoginHidden) {
    return /*#__PURE__*/_jsx(AccordionItem, {
      defaultOpen: false,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.smartLogin.passwordForGoogle"
      }),
      "data-test-id": "password-login-accordion",
      children: /*#__PURE__*/_jsx(PasswordField, {})
    });
  } else if (isPasswordLoginAvailable) {
    return /*#__PURE__*/_jsx(PasswordField, {});
  } else {
    return null;
  }
};
export default PasswordComponent;